import React from 'react';
import {useField} from 'react-final-form';
import Input from 'common/componentsV2/Input';

const validate = (value) => {
  return !value && 'Access Token is mandatory';
};

const AccessToken = ({isCreate}: {isCreate: boolean}) => {
  const {
    input: {value, onChange, onBlur},
    meta,
  } = useField('accessToken', {validate});
  return (
    <div>
      <div>Access Token</div>
      <div>
        <Input
          placeHolder="Select something"
          fullSize
          automationId="AccessToken"
          type={isCreate ? 'text' : 'password'}
          isInvalid={meta.touched && meta.error}
          invalidMessage={meta.error}
          isDisabled={!isCreate}
          value={isCreate ? value : '************'}
          onChange={onChange}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
};

export default AccessToken;
